/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_XDolar_88_36 as Componente_XDolar_88_36,
  rec_EstadoError as EstadoError,
  rec_IncidenciaEnviada as IncidenciaEnviada,
  rec_JSXRuntime as JSXRuntime,
  rec_ListaIncidencias as ListaIncidencias,
  rec_React as React,
  rec_ReportarIncidencia as ReportarIncidencia,
  rec_api as api,
  rec_es as es,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function SeleccionTipoIncidencia() {
  let [e, t] = (0, React.useState)(null),
    [n, r] = (0, React.useState)([]),
    [i, a] = (0, React.useState)(!0),
    [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(null),
    [u, f] = (0, React.useState)(null),
    p = (0, React.useRef)(null);
  async function m() {
    (a(!0), s(``));
    try {
      let [e, n] = await Promise.all([
        api(`/incidencias/catalogo`),
        api(`/incidencias/mias`),
      ]);
      (t(e), r(n ?? []));
    } catch (e) {
      s(e.message);
    } finally {
      a(!1);
    }
  }
  return (
    (0, React.useEffect)(() => {
      m();
    }, []),
    i && !e ? (
      <div
        className={`flex justify-center py-16 text-(--text)`}
        children={(0, JSXRuntime.jsx)(ii, {
          className: `h-6 w-6 animate-spin`,
        })}
      />
    ) : o ? (
      <EstadoError mensaje={o} onReintentar={m} />
    ) : u ? (
      <IncidenciaEnviada
        codigo={u.codigo}
        sinSenal={!!u.guardadoSinConexion}
        onOtra={() => f(null)}
        onVer={() => {
          (f(null),
            requestAnimationFrame(() =>
              p.current?.scrollIntoView?.({
                behavior: `smooth`,
              }),
            ));
        }}
      />
    ) : c ? (
      <ReportarIncidencia
        tipo={c}
        fundos={e.fundos ?? []}
        onCancelar={() => l(null)}
        onListo={(e) => {
          (l(null), f(e ?? {}), es(`exito`));
          try {
            navigator.vibrate?.([30, 40, 30]);
          } catch {}
          m();
        }}
      />
    ) : (
      <div
        className={`mx-auto flex w-full max-w-5xl flex-col gap-4`}
        children={[
          <section
            className={`flex flex-col gap-3`}
            children={[
              <h2
                className={`text-sm font-medium text-(--text-h) !m-0`}
                children={`¿Qué viste?`}
              />,
              e.tipos.length === 0 ? (
                <p
                  className={`${Bo} text-sm text-(--text)`}
                  children={`Todavía no hay nada configurado acá. Avisá a quien administra el sistema.`}
                />
              ) : (
                <div
                  className={`animar-cascada grid grid-cols-2 gap-3 sm:grid-cols-4`}
                  children={e.tipos.map((e) => (
                    <Componente_XDolar_88_36
                      key={e.id}
                      tipo={e}
                      onClick={() => l(e)}
                    />
                  ))}
                />
              ),
            ]}
          />,
          <div
            ref={p}
            children={<ListaIncidencias items={n} onRecargar={m} />}
          />,
        ]}
      />
    )
  );
}
